/* eslint-disable no-param-reassign */
/* eslint-disable no-return-assign */
/* eslint-disable no-unused-vars */
import { writable, derived } from 'svelte/store';
import dispatchEvent from '../../../utils/dispatch-event.js';

export const availableFacets = writable([]);
export const priceFacet = writable({});

export function updatePriceFacet(facet) {
  priceFacet.update(priceFacets => (priceFacets = facet));
}

export function setAvailableFacets(response) {
  availableFacets.set(response);
}

function createSelectedFacetsStore() {
  const { subscribe, set, update } = writable({});

  return {
    subscribe,
    set,
    toggle: (facet, option) => {
      update(store => {
        if (typeof store[facet] === 'undefined') {
          store[facet] = [option];
        } else if (store[facet].includes(option)) {
          store[facet] = store[facet].filter(opt => opt !== option);
        } else {
          store[facet].push(option);
        }
        return store;
      });
    },
  };
}

export const selectedFacets = createSelectedFacetsStore();

export const appliedFacets = derived(selectedFacets, $selectedFacets => {
  return Object.fromEntries(
    Object.entries($selectedFacets).map(([key, values]) => [
      `restrictBy[${key}]`,
      values.join('|'),
    ])
  );
  // return {
  //   'restrictBy[price]': '30, 40'
  // }
});

export function clearSelectedFacets() {
  selectedFacets.set({});
  dispatchEvent('facets:clear', window);
}
